import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
    // Check if the user session is verified
    const session = JSON.parse(localStorage.getItem('authSession'));
    const isVerified = session?.isVerified;

    if (isVerified) {
        // Redirect to dashboard if the user is signed in
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PublicRoute;